<template>
    <div>
    <b-nav tabs>
        <b-nav-item disabled><b>Comic Quiz App</b></b-nav-item>
        <b-nav-item disabled>Counter : {{curr+1}}/{{total}}</b-nav-item>
        <b-nav-item disabled>Correct : {{correct}}</b-nav-item>
        <b-nav-item @click='startAgain'>Start Again</b-nav-item>
    </b-nav>
    </div>
</template>

<script>
    export default{
        props:{
            curr:Number,
            correct:Number,
            total:Number,
            reset:Function,
        },
        methods:{
            startAgain:function(){
                this.reset()
            }
        }
    }
</script>